import { Theme } from "@material-ui/core/styles";

const styleTdTh = {
  cursor: "pointer",
  padding: "10px 16px",
  color: "black",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

const styleTdLastChild = {
  borderRadius: "0 12px 12px 0",
  lineHeight: "0.8em",
};
const styles = (theme: Theme) =>
  ({
    tableContainer: {
      maxHeight: "calc(100vh - 164px)",
      padding: "0 12px 4px 4px",
    },
    table: {
      borderCollapse: "inherit",
      borderSpacing: "0 4px",
      tableLayout: "fixed",
    },
    tableRow: {
      "& td, & th": {
        ...styleTdTh,
        background: theme.palette.primary.light,
        borderBottom: "none",
      },
      "& td:first-child": {
        borderRadius: "12px 0 0 12px",
      },
      "& td:last-child": {
        ...styleTdLastChild,
      },
      "&:hover": {
        background: "transparent !important",
      },
    },
    tableRowCollapsed: {
      "& td, & th": {
        padding: "0",
        border: "none",
      },
    },
    containerCollapsed: {
      marginTop: -4,
      background: theme.palette.primary.light,
      border: "0.2px solid rgba(92,92,92,0.3)",
      borderTop: "none",
      borderRadius: "0 0 12px 12px",
    },
    cellValue: {
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
    },
  } as any);

export default styles;
